import Types from "./types";
import { VehicleService } from "../../../service/vehicle-service";

const fetchDataSuccess = data => ({
    type: Types.FETCH_FRANCHISE_DATA_SUCCESS,
    data
});

const fetchDataFailure = () => ({
    type: Types.FETCH_FRANCHISE_DATA_FAILURE
});

const setDetails = data => ({
    type: Types.SET_DETAILS,
    data
});

const setIsSsr = isSsr => ({
    type: Types.SET_IS_SSR,
    isSsr
});

const fetchGalleryContent = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        VehicleService.fetchVideoGallery(payload)
            .then(response => {
                dispatch(setDetails({ testimonials: response.data.detail || [] }));
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {
    fetchDataFailure,
    fetchDataSuccess,
    setDetails,
    setIsSsr,
    fetchGalleryContent
};

